/*
 * @Date: 2020-03-13 18:27:19
 * @LastEditors: chentianyang
 * @LastEditTime: 2021-08-12 20:06:41
 * @FilePath: \st-teacher-2020\src\service\fetch.ts
 */
import axios from 'axios';
import cookies from 'js-cookie';
import AutoLoading from '../utils/autoLoading';
import Toast from '../utils/toast';
import aesUtils from '../utils/aesUtils';

const autoloading = new AutoLoading();
const toast = new Toast();

export default (options: any) => new Promise((resolve, reject) => {
  const instance = axios.create({
    // instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
    // 所有的请求都会带上这些配置，比如全局都要用的身份信息等。
    headers: options.headers || {},
    timeout: 30 * 1000, // 30秒超时
  });
  instance.interceptors.request.use(
    (req) => {
      const reqTemp = req;
      if (!options.noloading) {
        autoloading.show();
      }
      reqTemp.headers.token = cookies.get('token') || '';
      reqTemp.headers.ptpc = cookies.get('ptpc');
      reqTemp.headers.ptpcUserId = cookies.get('userId');
      return reqTemp;
    },
    (err) => Promise.reject(err),
  );
  instance(options).then(async (response) => { // then 请求成功之后进行什么操作
    autoloading.hide();
    const { headers } = response;
    const result = response.data;
    const { href } = window.location;
    const jumpUrl = process.env.VUE_APP_JUMPURL;

    if (headers.ptpc) {
      cookies.set('ptpc', headers.ptpc, { domain: '.aixuexi.com' });
    }
    if (headers.token) {
      cookies.set('token', headers.token, { domain: '.aixuexi.com' });
    }
    if (result.status === 1 || result.status === 200 || result.status === 204) {
      resolve(result.body);
    } else if (result.status === 10) {
      try {
        const { data } = await instance.get('/teaching/V2.0/token/getDecryptionKey');
        if (data.status === 1) {
          // 对base64转编码
          const decode = atob(data.body.slice(1));
          // 编码转字符串
          const str = decodeURI(decode);
          const key = str.slice(0, str.length - 1);
          // const key = 'WcQqwVB0AKt23GKl';
          const aesBody = aesUtils.decrypt(result.body, key);
          resolve(aesBody);
        } else {
          toast.show(data.errorMessage || '请求数据错误！');
        }
      } catch (error) {
        toast.show(error.message || '请求数据错误！');
      }
      autoloading.hide();
    } else {
      const duration = 5000;
      const errorCodeList = [1003, 1006, 1007, 1009, 1012, 100300001, 100300002, 100300003];
      if (errorCodeList.indexOf(result.errorCode) !== -1) {
        toast.show({
          message: result.errorMessage,
          duration,
        });
        setTimeout(() => {
          cookies.remove('token', { domain: '.aixuexi.com' });
          cookies.remove('ptpc', { domain: '.aixuexi.com' });
          const p = window.location.href.split('?')[1];
          const params = new URLSearchParams(p);
          if (params.get('fromPad')) {
            window.location.href = 'https://bsk.aixuexi.com/jzx/login';
          } else {
            window.location.href = `//www.aixuexi.com?loginBackUrl=${href}`;
          }
        }, duration);
      } else if (result.errorCode === 8888) {
        // 需要降级处理
        if (href.indexOf('downgrade.html') === -1) {
          toast.show({
            message: '服务降级处理',
            duration: 3000,
          });
          setTimeout(() => {
            window.location.href = `${jumpUrl}/downgrade.html`;
          }, 3000);
        }
      } else if (result.errorCode === 6666) {
        // 降级处理已修复
        window.location.href = './index.html';
      } else {
        toast.show(result.errorMessage || '接口异常');
      }
      reject(result);
    }
  }).catch((error) => {
    autoloading.hide();
    toast.show('请求数据错误！');
    reject(error);
  });
});
